import React, { useEffect, useState } from "react";
import { StylingStaff, Category } from "../../../types/salon.types";
import StaffCard from "./StaffCard";
import CategoryCard from "../common/CategoryCard";

interface StaffSectionProps {
  staffMembers: StylingStaff[];
  selectedStaff: StylingStaff | null;
  categories: Category[];
  onStaffSelect: (staff: StylingStaff) => void;
  onCategorySelect: (categoryId: string) => void;
  onClearSelection: () => void;
  resetStaffCategory?: boolean;
}

const StaffSection: React.FC<StaffSectionProps> = ({ staffMembers, selectedStaff, categories, onStaffSelect, onCategorySelect, onClearSelection, resetStaffCategory }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  useEffect(() => {
    if (resetStaffCategory) {
      setActiveCategory(null);
    }
  }, [resetStaffCategory]);

  const filteredStaff = staffMembers.filter((staff) => {
    const name = `${staff.firstName ?? ""} ${staff.middleName ?? ""} ${staff.lastName ?? ""}`.trim().toLowerCase();

    return name.includes(searchQuery.trim().toLowerCase());
  });

  const serviceCategories = categories.filter((cat) => cat.type === "Services");

  return (
    <div className="staff-section">
      <h2 className="saloon-title">Staff Members</h2>

      <div className="staff-container">
        {selectedStaff ? (
          <div className="staff-card-container">
            <h2>{`${selectedStaff.firstName} ${selectedStaff.middleName} ${selectedStaff.lastName}`}</h2>
            <div className="category-cards">
              {serviceCategories.length > 0 ? (
                serviceCategories.map((category) => (
                  <CategoryCard
                    key={category._id.$oid}
                    category={category}
                    onClick={() => {
                      setActiveCategory(category._id.$oid); // 👈 update active category
                      onCategorySelect(category._id.$oid);
                    }}
                    isActive={activeCategory === category._id.$oid} // 👈 pass down active state
                  />
                ))
              ) : (
                <p className="no-categories">No categories found.</p>
              )}
            </div>

            <button onClick={onClearSelection} className="back-button">
              ← Back to Staff List
            </button>
          </div>
        ) : (
          <>
            {filteredStaff.length > 0 ? (
              filteredStaff.map((staff) => <StaffCard key={staff._id.$oid} staff={staff} onClick={() => onStaffSelect(staff)} />)
            ) : (
              <p className="no-staff">No staff found.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StaffSection;
